import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "04573ebe-168d-4f0e-ad5c-a9477c132554",
  title: "Fly Frontier",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-US",
  currency: "USD",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon-16x16.png", "favicon-32x32.png", "favicon.ico"],
  logo: "/assets/images/logo.svg",
  domain: "activities.flyfrontier.com",
  detectLocale: true,
  detectCurrency: true,
};
